import { FC } from 'react'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Button from 'components/features/pfm/Button/Button'
import moment from 'moment'
import { useStoreSelector } from 'helpers/reactReduxHelpers'


export const EligibilityFailedContent: FC = () => {
  const next_available_attempt_time = useStoreSelector((state) => state.data.creditCard.onboarding?.next_available_attempt_time ?? null)
  if (!next_available_attempt_time) {
    return null
  }

  const timeLeft = moment(next_available_attempt_time).diff()
  const daysLeft = moment.duration(timeLeft).asDays()
  const ceilDaysLeft = Math.ceil(daysLeft)

  return (
    <>
      <h2>
        Your application was not approved.
      </h2>
      <strong>
        Please try applying again in <strong>{ ceilDaysLeft }</strong> days.
      </strong>
      <p>
        We understand that this may not be the decision that you were expecting. You will receive a notification from us
        advising you of the reasons for the decline.
      </p>
      <NavigationLink to='opportunities'>
        <Button size='medium' text='See Other Offers' fullWidth />
      </NavigationLink>
    </>
  )
}
